<template>
  <div class="flex justify-center items-start px-4">
    <div v-if="isLoading" class="fixed inset-0 z-[100] bg-base-100/80 backdrop-blur-sm flex items-center justify-center">
      <NavLoading />
    </div>
    <div class="w-full max-w-md">
      <div class="card w-full shadow-2xl bg-base-100">
        <form class="card-body" @submit.prevent="handleSignup">
          <h2 class="card-title text-2xl font-bold mb-4">Create Account</h2>
          
          <div class="form-control">
            <label class="label"><span class="label-text">Full Name</span></label>
            <input 
              v-model="name" 
              type="text" 
              placeholder="John Doe" 
              class="input input-bordered focus:ring-2 ring-primary/20" 
              required 
            >
          </div>

          <div class="form-control">
            <label class="label"><span class="label-text">Mobile Number</span></label>
            <input 
              v-model="phone" 
              type="tel" 
              minlength="11" 
              maxlength="11"
              placeholder="01X-XX-XXXXXX" 
              class="input input-bordered focus:ring-2 ring-primary/20" 
              required 
            >
          </div>

          <div class="form-control mt-6">
            <button class="btn btn-primary w-full text-white" :disabled="isLoading">
              {{ isLoading ? 'Processing...' : 'Send OTP' }}
            </button>
          </div>
          
          <p class="text-sm text-center mt-6">
            Already have an account? <NuxtLink to="/login" class="link link-primary font-semibold">Login</NuxtLink>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'auth'
})
const name = ref('');
const phone = ref('');
const isLoading = ref(false);
const config = useRuntimeConfig()
const url = config.public.apiBase; 
const { addToast } = useToast();

const handleSignup = async () => {
  isLoading.value = true;
  try {
    const response = await $fetch(url+'/auth/register', {
      method: 'POST',
      body: {
        name:  name.value,
        phone: phone.value,
        type:  "customer"
      },
      headers: {
        'Accept': 'application/json',
      }
    });
    addToast(response.message, 'alert-success');
    navigateTo({
      path: '/otp',
      query: { phone: phone.value },
      replace: true
    });
  } catch (err) {
    const msg = err.data?.message || 'Signup failed';
    addToast(msg, 'alert-error'); 
  } finally {
    isLoading.value = false;
  }
};
</script>
